// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "../../";

import { HTMLDivProps } from "@blueprintjs/core";

import {
  IMultiMediaInActiveProps,
  MultiMediaInActive
} from "./multimedia-inactive";

import { IMultiMediaActiveProps, MultiMediaActive } from "./multimedia-active";

import "./styles.css";

export interface IMultiMediaProps
  extends HTMLDivProps,
    IMultiMediaActiveProps,
    IMultiMediaInActiveProps {
  multiMedia: any;
}

export const MultiMedia: React.SFC<IMultiMediaProps> = props => {
  const {
    className,
    multiMedia,
    onMultiMediaOnDrop,
    onRecordAudio,
    onMultiMediaStateChange,
    onMultiMediaClicked
  } = props;

  const classes = classNames(
    myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER,
    "multimedia-container",
    className
  );

  return (
    <div className={classes}>
      <MultiMediaInActive
        onMultiMediaClicked={onMultiMediaClicked}
        multiMedia={multiMedia}
      />
      <MultiMediaActive
        multiMedia={multiMedia}
        onRecordAudio={onRecordAudio}
        onMultiMediaOnDrop={onMultiMediaOnDrop}
        onMultiMediaStateChange={onMultiMediaStateChange}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/multimedia/multimedia.tsx